import React from 'react';
import util from 'utils/utils';
import { Trans } from 'react-i18next';

export default function groupLeftContent({ events, ownerGroup = { name: 'Undefined' } }) {
  return (
    <Trans i18nKey="notifications.groupLeft">
      <b>{{ name: util.getEventUsers(events) }}</b>
      has left the group you lead
      <b>{{ group: ownerGroup.name }}</b>
    </Trans>
  );
}
